import React, { createContext, useCallback, useState, useContext } from 'react';
import IPedidoVenda from '../pages/MonitorPedidos/utils/IPedidoVenda';

interface MonitorPedido {
  pedido: IPedidoVenda;
}

interface MonitorContextData {
  monitorPedido: MonitorPedido;
  wasUpdated: boolean;
  tabChanged: boolean;
  hasPedidoEmAguardo: boolean;

  handleSetMonitorPedido(pedido: IPedidoVenda): void;
  handleSetWasUpdated(value: boolean): void;
  handleSetTabChanged(value: boolean): void;
  handleClearMonitor(): void;
  handleSetHasPedidoEmAguardo(value: boolean): void;
}

const MonitorContext = createContext<MonitorContextData>(
  {} as MonitorContextData,
);

const MonitorProvider: React.FC = ({ children }) => {
  const [monitorPedido, setMonitorPedido] = useState<MonitorPedido>(() => {
    return {} as MonitorPedido;
  });
  const [wasUpdated, setWasUpdated] = useState(false);
  const [tabChanged, setTabChanged] = useState(false);
  const [hasPedidoEmAguardo, setHasPedidoEmAguardo] = useState(false);

  const handleSetMonitorPedido = useCallback((pedido: IPedidoVenda): void => {
    setMonitorPedido({ pedido: { ...pedido } });
  }, []);

  const handleSetWasUpdated = useCallback((value: boolean): void => {
    setWasUpdated(value);
  }, []);

  const handleSetTabChanged = useCallback((value: boolean): void => {
    setTabChanged(value);
  }, []);

  const handleClearMonitor = useCallback((): void => {
    setMonitorPedido(() => {
      return {} as MonitorPedido;
    });
  }, []);

  const handleSetHasPedidoEmAguardo = useCallback((value: boolean): void => {
    setHasPedidoEmAguardo(value);
  }, []);

  return (
    <MonitorContext.Provider
      value={{
        monitorPedido,
        wasUpdated,
        tabChanged,
        hasPedidoEmAguardo,
        handleSetMonitorPedido,
        handleSetWasUpdated,
        handleSetTabChanged,
        handleClearMonitor,
        handleSetHasPedidoEmAguardo,
      }}
    >
      {children}
    </MonitorContext.Provider>
  );
};

function useMonitor(): MonitorContextData {
  const context = useContext(MonitorContext);

  if (!context)
    throw new Error('useMonitor deve ser utilizado junto do MonitorProvider');

  return context;
}

export { MonitorProvider, useMonitor };
